import get from 'lodash/get'
import last from 'lodash/last'
import {createSelector} from 'reselect'

import {hasLength} from './helpers'

// Get

export const canonicalHref = (state) => get(state, 'site.canonicalHref')
export const hideFooter = (state) => get(state, 'site.hideFooter')
export const isFooterVisible = (state) => get(state, 'site.isFooterVisible')
export const lockWindow = (state) => get(state, 'site.lockWindow')
export const nextUrl = (state) => get(state, 'site.next')

// Boolean
export const minNavIsActive = (state) => !!get(state, 'site.minNavIsActive')
export const windowOnloadFired = (state) => !!get(state, 'site.windowOnloadFired')

// Computed

export const windowIsLocked = createSelector(lockWindow, hasLength)

export const topLock = createSelector(lockWindow, last)

export const topLockX = createSelector(topLock, (a) => get(a, 'x'))

export const topLockY = createSelector(topLock, (a) => get(a, 'y'))
